import React, {Component} from "react";
import {connect} from "react-redux";
import TawkTo from "tawkto-react";
import {TawkBotConfig} from "../../../utils/const";
import {updateTawkBot} from "../../../redux_actions/gamma.state.action";

class TawkBot extends Component {

	constructor(props) {
		super(props);

	}

	componentDidMount = () => {
		if(!this.props.gammaState.tawkBot){
			let newTawkBot = new TawkTo(TawkBotConfig.propertyId, TawkBotConfig.widgetId);
			newTawkBot.setAttributes(
				{
					visibility: {
						position: 'br'
					}
				},
				function (error) {
					console.log("tawkbot", error);
				}
			)
			newTawkBot.showWidget();
			this.props.dispatch(updateTawkBot(newTawkBot));
		}else{
			this.props.gammaState.tawkBot.showWidget();
		}
	}

	componentWillUnmount() {
		if(this.props.gammaState.tawkBot){
			this.props.gammaState.tawkBot.hideWidget();
		}
	}

	render() {
		// TawkTo API automcatically creates an element and appends it to the page, no need to return anything here.
		return <></>
	}
}

const mapStateToProps = (state) => {
	return {
		gammaState: state.gammaStateReducer,
	}
}

export default connect(mapStateToProps)(TawkBot);